import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const adminLogin = async (data) => {
  const url = `${BASE_URL}/accounts/login/`;
  // console.log(url)

  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized access. Redirecting to login page.", error.response);
      return error.response;
    } else {
      console.log("Error during login:", error);
    }
  }
};

export const adminLogout = async (token, data) => {
  const url = `${BASE_URL}/accounts/logout/`;
  // console.log(url)


  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized Logout", error.response);
      return error.response;
    } else {
      console.log("Error during logout:", error);
    }
  }
};

export const forgotPassword = async (data) => {
  const url = `${BASE_URL}/accounts/forgot-password/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getDashbordData = async (token) => {
  const url = `${BASE_URL}/order/orders_brand__user/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllBusinessDetails = async (token) => {
  const url = `${BASE_URL}/accounts/business/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getBusinessDetails = async (token, businessId) => {
  const url = `${BASE_URL}/accounts/business/${businessId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const createBusinessDetails = async (token, data) => {
  const url = `${BASE_URL}/accounts/business/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateBusinessDetails = async (token, data, businessId) => {
  const url = `${BASE_URL}/accounts/business/${businessId}/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.put(url, data, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const changePassword = async (token, data) => {
  const url = `${BASE_URL}/accounts/reset-password/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

